import Vue from 'vue'
import Vuex from 'vuex'

import client from './client'
import currentUser from './current_user'
import management from './management'
import { routeManagerPlugin } from './plugins'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    client,
    currentUser,
    management
  },
  plugins: [
    routeManagerPlugin
  ]
})
